import { Map } from 'immutable';
import type {
  AnyViewState,
  ReduxAction,
  RestorableViewID,
  ViewRestorationState,
} from '@repo/utils/types';

const defaultViewRestorationState = Map<RestorableViewID, AnyViewState>({
  Activity: null,
  People: null,
});

export function viewRestorationReducer(
  state: ViewRestorationState = defaultViewRestorationState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'SAVE_VIEW_STATE':
      return state.set(payload.viewID, payload.state);

    case 'DELETE_CONTACT_BATCH_REQUESTED':
    case 'DELETE_CONTACT_REQUESTED':
      const deletedContactIDs = payload.contact_ids || [payload.id];
      return state.map((viewState) => {
        if (viewState?.selectedContactBatch) {
          const updatedBatch = viewState.selectedContactBatch.filter(
            (contactID) => !deletedContactIDs.includes(contactID),
          );
          return { ...viewState, selectedContactBatch: updatedBatch };
        }

        return viewState;
      });

    default:
      return state;
  }
}
